import React, { useEffect, useRef } from "react";
import blueStarSrc from "../../../assets/img/jpg/blue-star.png";
import pinkStarSrc from "../../../assets/img/jpg/pink-star.png";
import { RoadmapEvent } from "../../RoadmapEvent";
import { useTranslation } from "react-i18next";
import styles from "./Roadmap.module.scss";
import useMediaQuery from "../../../hooks/useMediaQuery";
import { Swiper, SwiperSlide } from "swiper/react";

const canvasWidth = 1200;
const canvasHeight = 470;

const RoadmapCanvas = () => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const blueStar = useRef<HTMLImageElement>(null);
    const pinkStar = useRef<HTMLImageElement>(null);

    const { t } = useTranslation();

    useEffect(() => {
        if (!canvasRef.current || !blueStar.current || !pinkStar.current) return;

        const ctx = canvasRef.current.getContext("2d");

        if (!ctx) return;

        ctx.beginPath();
        ctx.strokeStyle = "#fff";
        ctx.lineWidth = 2;
        ctx.fillStyle = "transparent";

        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);

        // НИЖНЯЯ ЛИНИЯ  <------ НАЧАЛО ------->

        ctx.moveTo(0, 286);
        ctx.lineTo(2, 286);

        ctx.moveTo(5, 286);
        ctx.lineTo(7, 286);

        ctx.moveTo(10, 286);
        ctx.lineTo(12, 286);

        ctx.moveTo(15, 286);
        ctx.lineTo(640, 286);

        ctx.arc(640, 264, 22, (1 / 2) * Math.PI, (-1 / 2) * Math.PI, true);

        ctx.lineTo(555, 242);

        ctx.arc(555, 178, 64, (1 / 2) * Math.PI, (-1 / 2) * Math.PI, false);

        ctx.lineTo(1200, 114);
        ctx.lineTo(1193, 107);

        ctx.moveTo(1200, 114);
        ctx.lineTo(1193, 121);

        // ВЕРХНЯЯ ЛИНИЯ  <------ КОНЕЦ ------->

        ////////////////////////////////////////

        // НИЖНЯЯ ЛИНИЯ  <------ НАЧАЛО ------->

        ctx.moveTo(1198, 156);
        ctx.lineTo(1196, 156);

        ctx.moveTo(1193, 156);
        ctx.lineTo(1191, 156);

        ctx.moveTo(1188, 156);
        ctx.lineTo(1186, 156);

        ctx.moveTo(1183, 156);
        ctx.lineTo(555, 156);

        ctx.arc(555, 178, 22, (-1 / 2) * Math.PI, (1 / 2) * Math.PI, true);

        ctx.lineTo(640, 200);

        ctx.arc(640, 264, 64, (-1 / 2) * Math.PI, (1 / 2) * Math.PI, false);

        ctx.lineTo(0, 328);

        // НИЖНЯЯ ЛИНИЯ  <------ КОНЕЦ ------->

        ctx.fill();

        ctx.stroke();

        ctx.drawImage(pinkStar.current, 0, 295);
        ctx.drawImage(pinkStar.current, 380, 295);
        ctx.drawImage(pinkStar.current, 705, 123);
        ctx.drawImage(pinkStar.current, 980, 123);

        ctx.drawImage(blueStar.current, 195, 253);
        ctx.drawImage(blueStar.current, 515, 81);
        ctx.drawImage(blueStar.current, 855, 81);
    });

    const matches = useMediaQuery("(min-width: 750px)");

    return (
        <div className={styles.canvasWrap}>
            {matches ? (
                <>
                    <div style={{ height: 0, opacity: 0 }}>
                        <img ref={blueStar} src={blueStarSrc} />
                        <img ref={pinkStar} src={pinkStarSrc} />
                    </div>
                    <canvas style={{ width: "100%" }} ref={canvasRef} width={canvasWidth} height={canvasHeight}></canvas>
                    <RoadmapEvent
                        date={t("landing.roadmap.q1.date")}
                        description={t("landing.roadmap.q1.text")}
                        // above={true}
                        className={styles.event0}
                    />
                    <RoadmapEvent
                        date={t("landing.roadmap.q2.date")}
                        description={t("landing.roadmap.q2.text")}
                        above={true}
                        className={styles.event1}
                    />
                    <RoadmapEvent
                        date={t("landing.roadmap.q3.date")}
                        description={t("landing.roadmap.q3.text")}
                        // above={true}
                        className={styles.event2}
                    />
                    <RoadmapEvent
                        date={t("landing.roadmap.q4.date")}
                        description={t("landing.roadmap.q4.text")}
                        above={true}
                        className={styles.event3}
                    />
                    <RoadmapEvent
                        date={t("landing.roadmap.q5.date")}
                        description={t("landing.roadmap.q5.text")}
                        // above={true}
                        className={styles.event4}
                    />
                    <RoadmapEvent
                        date={t("landing.roadmap.q6.date")}
                        description={t("landing.roadmap.q6.text")}
                        above={true}
                        className={styles.event5}
                    />
                    <RoadmapEvent
                        date={t("landing.roadmap.q7.date")}
                        description={t("landing.roadmap.q7.text")}
                        // above={true}
                        className={styles.event6}
                    />
                </>
            ) : (
                <Swiper slidesPerView={1.7} spaceBetween={0} grabCursor={true}>
                    <SwiperSlide className={styles.slide}>
                        <RoadmapEvent
                            date={t("landing.roadmap.q1.date")}
                            description={t("landing.roadmap.q1.text")}
                            // above={true}
                            className={styles.event0}
                        />
                    </SwiperSlide>
                    <SwiperSlide className={styles.slide}>
                        <RoadmapEvent
                            date={t("landing.roadmap.q2.date")}
                            description={t("landing.roadmap.q2.text")}
                            above={true}
                            className={styles.event1}
                        />
                    </SwiperSlide>
                    <SwiperSlide className={styles.slide}>
                        <RoadmapEvent
                            date={t("landing.roadmap.q3.date")}
                            description={t("landing.roadmap.q3.text")}
                            // above={true}
                            className={styles.event2}
                        />
                    </SwiperSlide>
                    <SwiperSlide className={styles.slide}>
                        <RoadmapEvent
                            date={t("landing.roadmap.q4.date")}
                            description={t("landing.roadmap.q4.text")}
                            above={true}
                            className={styles.event3}
                        />
                    </SwiperSlide>
                    <SwiperSlide className={styles.slide}>
                        <RoadmapEvent
                            date={t("landing.roadmap.q5.date")}
                            description={t("landing.roadmap.q5.text")}
                            // above={true}
                            className={styles.event4}
                        />
                    </SwiperSlide>
                    <SwiperSlide className={styles.slide}>
                        <RoadmapEvent
                            date={t("landing.roadmap.q6.date")}
                            description={t("landing.roadmap.q6.text")}
                            above={true}
                            className={styles.event5}
                        />
                    </SwiperSlide>
                    <SwiperSlide className={styles.slide}>
                        <RoadmapEvent
                            date={t("landing.roadmap.q7.date")}
                            description={t("landing.roadmap.q7.text")}
                            // above={true}
                            className={styles.event6}
                        />
                    </SwiperSlide>
                    <SwiperSlide className={styles.slide}>
                        <RoadmapEvent
                            date={t("landing.roadmap.q8.date")}
                            description={t("landing.roadmap.q8.text")}
                            above={true}
                            className={styles.event7}
                        />
                    </SwiperSlide>
                </Swiper>
            )}
        </div>
    );
};

export default RoadmapCanvas;
